module.exports = __webpack_public_path__ + "images/application/libs-logos@2x-0a66cd92.png";